enum ActionTypes {
  SET_JOB_APPLICATION_DATA = 'careers/JobApplication/SET_JOB_APPLICATION_DATA',
  SUBMIT_JOB_APPLICATION = 'careers/JobApplication/SUBMIT_JOB_APPLICATION',
  SUBMIT_JOB_APPLICATION_SUCCESS = 'careers/JobApplication/SUBMIT_JOB_APPLICATION_SUCCESS',
  SUBMIT_JOB_APPLICATION_FAILURE = 'careers/JobApplication/SUBMIT_JOB_APPLICATION_FAILURE',
}
export default ActionTypes;